export const business = {
  name: 'East End Automotive Repair LLC',
  shortName: 'East End Automotive',
  contact: 'Percy Purcell',
  phone: '(865) 206-2279',
  phoneHref: 'tel:+18652062279',
  mobile: '(865) 443-6615',
  mobileHref: 'tel:+18654436615',
  email: 'percy@eeautomotiverepair.com',
  address: {
    street: '274 Warehouse Rd',
    city: 'Oak Ridge',
    state: 'TN',
    zip: '37830',
  },
  hours: [
    { days: 'Monday – Friday', time: '8:00 AM – 5:00 PM' },
    { days: 'Saturday', time: 'Closed' },
    { days: 'Sunday', time: 'Closed' },
  ],
  logoUrl:
    'https://eeautomotiverepair.com/wp-content/uploads/sites/860/2023/11/East-End-Automotive-Repair-LLC-Logo.png',
}

export const socials = [
  { label: 'Facebook', href: 'https://www.facebook.com/EastEndautorepair' },
  { label: 'Instagram', href: 'https://www.instagram.com/eastendautorepair1' },
  { label: 'TikTok', href: 'https://www.tiktok.com/@eastendautomotiverepair' },
  {
    label: 'SureCritic',
    href: 'https://www.surecritic.com/reviews/east-end-automotive-repair-llc',
  },
  {
    label: 'Yelp',
    href: 'https://www.yelp.com/biz/east-end-automotive-repair-oak-ridge',
  },
]

export const photos = {
  building:
    'https://eeautomotiverepair.com/wp-content/uploads/sites/860/2025/06/EAST-END-AUTOMOTIVE-REPAIR-LLC-BUILDING.jpg',
  shopMechanic:
    'https://eeautomotiverepair.com/wp-content/uploads/sites/860/2025/06/ficing-car.jpg',
  clipboard:
    'https://eeautomotiverepair.com/wp-content/uploads/sites/860/2025/06/Mechanic-holding-clipboard.png',
  truck:
    'https://eeautomotiverepair.com/wp-content/uploads/sites/860/2025/06/truck-getting-repair.jpg',
  whiteCar:
    'https://eeautomotiverepair.com/wp-content/uploads/sites/860/2025/06/white-car-getting-repaired.jpg',
  condition:
    'https://eeautomotiverepair.com/wp-content/uploads/sites/860/2026/04/condition-image.jpg',
  cause:
    'https://eeautomotiverepair.com/wp-content/uploads/sites/860/2026/04/cause-image.jpg',
}

export const navLinks = [
  { label: 'The East End Way', href: '#the-east-end-way' },
  { label: 'Services', href: '#services' },
  { label: 'Reviews', href: '#reviews' },
  { label: 'Shop', href: '#shop-experience' },
  { label: 'Contact', href: '#contact' },
]

export type Service = {
  name: string
  description: string
  icon: string
}

export const services: Service[] = [
  {
    name: 'Professional Vehicle Diagnostics',
    description:
      'Up-to-date diagnostic equipment and a documented process to find the real cause, not just the symptom.',
    icon: 'gauge',
  },
  {
    name: 'Standard Maintenance & Oil Changes',
    description:
      'Scheduled maintenance and oil service that keeps your vehicle on the manufacturer’s interval.',
    icon: 'droplet',
  },
  {
    name: 'Auto Electrical Services',
    description:
      'Batteries, charging systems, wiring and electrical faults traced and corrected.',
    icon: 'zap',
  },
  {
    name: 'Engine Service',
    description:
      'Engine performance concerns, repairs and service work handled by trained technicians.',
    icon: 'cog',
  },
  {
    name: 'Exhaust Services',
    description:
      'Exhaust inspection, repair and replacement for noise, leaks and emissions concerns.',
    icon: 'wind',
  },
  {
    name: 'Heating & Air Conditioning Repair',
    description:
      'A/C performance testing, heating concerns and climate control system repair.',
    icon: 'thermometer',
  },
  {
    name: 'Alignment Service',
    description:
      'Alignment work to correct handling, steering pull and uneven tire wear.',
    icon: 'crosshair',
  },
  {
    name: 'Transmission Service',
    description:
      'Transmission service and repair, with a clear explanation of the options before work begins.',
    icon: 'settings2',
  },
  {
    name: 'General Repair & Maintenance',
    description:
      'Brakes, suspension, steering and the everyday repairs that keep your vehicle safe.',
    icon: 'wrench',
  },
]

export const fourCs = [
  {
    label: 'Condition',
    copy: 'We start by confirming exactly what the vehicle is doing — what you experienced, and what we can verify ourselves.',
  },
  {
    label: 'Cause',
    copy: 'We test and diagnose until we know the underlying cause, instead of replacing parts and hoping.',
  },
  {
    label: 'Correction',
    copy: 'We explain the correction, the options, and the tradeoffs so you can make an informed decision.',
  },
  {
    label: 'Confirm',
    copy: 'We verify the repair fixed the original condition before the vehicle goes back to you.',
  },
]

export const trustPoints = [
  { stat: '5.0', label: '92 verified reviews on SureCritic' },
  { stat: '1 yr / 12k mi', label: 'Parts & labor warranty' },
  { stat: 'FCA Factory Trained', label: 'Chrysler · Dodge · Jeep' },
  { stat: '55+ Years', label: 'Combined technician experience' },
  { stat: 'Financing', label: 'Available through Snap' },
]

export const recentWork = [
  {
    title: 'Diagnostics & electrical',
    image: photos.whiteCar,
    caption:
      'Photo feed placeholder — recent service photos can be connected during build.',
  },
  {
    title: 'Light truck repair',
    image: photos.truck,
    caption:
      'Photo feed placeholder — recent service photos can be connected during build.',
  },
  {
    title: 'General repair & maintenance',
    image: photos.shopMechanic,
    caption:
      'Photo feed placeholder — recent service photos can be connected during build.',
  },
]
